import Vue from 'vue'
import Router from 'vue-router'
import Oma from './views/Oma.vue'
import Kohde from './views/Kohde.vue'
import Vahvista from './views/Vahvista.vue'
import Root from './views/Root.vue'
import store from './store'

Vue.use(Router)


var router = new Router({
	routes: [
		{
			path: '/',
			name: '',
			component: Root,
			beforeEnter: (to, from, next) => {
				if (store.state.carts.length > 0) {
					if (store.state.carts[0].account_name == 'Oma Varasto') next('oma')
					else next('kohde')
				} else next()
			}
		},
		{
			path: '/oma',
			name: 'Oma Varasto',
			component: Oma,
			beforeEnter: (to, from, next) => {
				if (store.state.carts.length == 0) {
					store.dispatch('omacart')
					next()
				}
				else if (store.state.carts[0].account_name == 'Oma Varasto') {
					next()
				}
				else next('kohde')
			}
		},
		{
			path: '/kohde',
			name: '',
			component: Kohde,
			beforeEnter: (to, from, next) => {
				if (store.state.carts.length == 0) next('/')
				else if (store.state.carts[0].account_name == 'Oma Varasto') next('oma')
				else next()
			}
		},
		{
			path: '/vahvista',
			name: 'Vahvista',
			component: Vahvista,
			beforeEnter: (to, from, next) => {
				store.state.carts.length == 0 ? next('/') : next()
			}
		},
		{
			path: '*',
			redirect: '/'
		}
	]
})

router.beforeEach((to, from, next) => {
	store.state.autofocus = from.name == 'Vahvista' ? false : true
	next()
})

export default router